import React from 'react';
import { styled } from '@mui/material/styles';
import Pagination from '@mui/material/Pagination';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import PaginationItem from '@mui/lab/PaginationItem';
import { useTranslation, Trans } from 'react-i18next';

const StyledPagination = styled(Pagination)(({ theme }) => ({
    marginTop: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center',
}));

const StyledPaginationItem = styled(PaginationItem)(({ theme }) => ({
    '&:hover': {
        backgroundColor: 'transparent',
    },
    '&.Mui-selected': {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.background.default,
        fontWeight: '900',
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
        },
    },
    '&.Mui-selected:hover': {
        backgroundColor: 'inherit',
    },
    '&.MuiPaginationItem-page': {
        color: theme.palette.disabled?.[500],
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
}));

export function PaginationMUI ({ totalPages, currentPage, onPageChange, totalSize }) {
    const { t } = useTranslation();
    const exceedLimit = totalSize > 1000;

    const handlePageChange = (_, page) => {
        onPageChange(page);
    };

    return (
        <StyledPagination
            count={totalPages}
            page={currentPage}
            onChange={handlePageChange}
            showLastButton={true}
            renderItem={(item) => {
                if (item.page === totalPages + 1 && exceedLimit) {
                    return (
                        <Tooltip
                            title={
                                <span><Trans i18nKey="pagination.warning" /></span>
                            }
                            placement="top"
                        >
                            <IconButton sx={{ cursor: 'not-allowed' }} size="large">
                                <KeyboardArrowRight />
                            </IconButton>
                        </Tooltip>
                    );
                }
                return <StyledPaginationItem {...item} />;
            }}
        />
    );
}
